import BaseObject from '../../../../../base/base_object';
import {SERIAL_PROVIDER} from '../serial_const';
import AppFlayer from './appsflyer/app_flayer';

class SerialProvider extends BaseObject {

    static CLASS = 'SerialProvider';


    /**
     *
     * @param type: the provider(appsflayer, ADX...)
     * @param param:
     * @returns {*}
     */
    getCurrentProvider(type, param) {
        switch (type) {
            case SERIAL_PROVIDER.APP_FLYER:
                return AppFlayer.create(param);
            default:
                return null;
        }
    }
}

export default SerialProvider;